import { useState, useEffect } from 'react';
import { MemberSidebar } from './MemberDashboard';
import api from '../lib/api';
import { MapPin, CalendarBlank, Car, X } from '@phosphor-icons/react';

const STATUS_LABELS = {
  PENDING: { label: 'En attente', color: 'bg-yellow-500/20 text-yellow-400' },
  CONFIRMED: { label: 'Confirmee', color: 'bg-blue-500/20 text-blue-400' },
  IN_PROGRESS: { label: 'En cours', color: 'bg-green-500/20 text-green-400' },
  DONE: { label: 'Terminee', color: 'bg-desti-gold/20 text-desti-gold' },
  CANCELLED: { label: 'Annulee', color: 'bg-red-500/20 text-red-400' },
};

export default function MemberBookings() {
  const [bookings, setBookings] = useState([]);

  useEffect(() => {
    api.get('/bookings/my').then(r => setBookings(r.data)).catch(() => {});
  }, []);

  const handleCancel = async (id) => {
    if (!window.confirm('Annuler cette reservation ?')) return;
    try {
      await api.put(`/bookings/${id}/cancel`);
      setBookings(prev => prev.map(b => b.id === id ? { ...b, status: 'CANCELLED' } : b));
    } catch (e) {
      alert('Impossible d\'annuler cette reservation.');
    }
  };

  return (
    <div className="pt-20 min-h-screen" data-testid="member-bookings-page">
      <div className="max-w-7xl mx-auto px-6 md:px-12 py-12">
        <div className="flex flex-col lg:flex-row gap-8">
          <MemberSidebar />
          <div className="flex-1">
            <h1 className="font-heading text-3xl text-white mb-8">Mes reservations</h1>
            {bookings.length === 0 ? (
              <div className="bg-desti-surface border border-white/5 p-12 text-center">
                <Car size={48} weight="duotone" className="text-white/20 mx-auto mb-4" />
                <p className="text-desti-text">Aucune reservation pour le moment.</p>
              </div>
            ) : (
              <div className="space-y-4">
                {bookings.map((b) => {
                  const st = STATUS_LABELS[b.status] || STATUS_LABELS.PENDING;
                  return (
                    <div key={b.id} className="bg-desti-surface border border-white/5 p-5" data-testid={`booking-item-${b.id}`}>
                      <div className="flex items-start justify-between mb-3">
                        <div>
                          <span className={`text-xs px-2 py-1 ${st.color}`}>{st.label}</span>
                          <p className="text-xs text-white/30 mt-2">#{b.id?.slice(-8).toUpperCase()}</p>
                        </div>
                        <p className="text-lg text-white font-medium">{b.priceTTC?.toFixed(2)} EUR</p>
                      </div>
                      <div className="space-y-2 text-sm">
                        <div className="flex items-start gap-2 text-white/60">
                          <MapPin size={14} className="text-desti-gold mt-0.5" />
                          <span>{b.pickupAddress} &rarr; {b.dropoffAddress}</span>
                        </div>
                        <div className="flex items-center gap-2 text-white/60">
                          <CalendarBlank size={14} className="text-desti-gold" />
                          <span>{b.pickupDate} a {b.pickupTime}</span>
                        </div>
                        <div className="flex items-center gap-2 text-white/60">
                          <Car size={14} className="text-desti-gold" />
                          <span>{b.vehicleName || b.vehicleType} - {b.distanceKm} km</span>
                        </div>
                      </div>
                      {['PENDING', 'CONFIRMED'].includes(b.status) && (
                        <button onClick={() => handleCancel(b.id)}
                          className="mt-3 flex items-center gap-1 text-xs text-red-400 hover:text-red-300 transition-colors"
                          data-testid={`cancel-booking-${b.id}`}>
                          <X size={12} /> Annuler
                        </button>
                      )}
                    </div>
                  );
                })}
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
